import styled, { css } from 'styled-components';
import { otherColors, secondaryColors } from '@tryhackme/thm-ui-components';

import { CommonContentStyles } from 'src/common/legacy-styles';
import { RoomHeaderStyles } from 'src/common/styles/';

import { CredentialsCardStyles } from './credentials-card.styles';

export const StyledAccordionDetailsMain = styled.div<{
  $isTaskBreakdownSupported: boolean;
  $isDarkMode: boolean;
  $isAskEchoEnabled: boolean;
}>`
  padding: ${({ $isTaskBreakdownSupported }) => ($isTaskBreakdownSupported ? 0 : '3rem')};

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    padding: ${({ $isTaskBreakdownSupported }) => ($isTaskBreakdownSupported ? 0 : '3rem 1.8rem')};
  }
  ${RoomHeaderStyles}
  // legacy compatibility styles
  ${CommonContentStyles}

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${({ $isTaskBreakdownSupported, theme, $isDarkMode }) => {
      if ($isTaskBreakdownSupported) {
        return $isDarkMode ? theme.colors.grey[100] : otherColors.textL;
      }
      return theme.colors.text.main;
    }};
    ${({ $isTaskBreakdownSupported }) =>
      $isTaskBreakdownSupported &&
      `
        font-size: 2.4rem;
        font-weight: 500;
        margin-bottom: 1.6rem;
        margin-top: 4.6rem;
    `};
  }
  ${({ $isTaskBreakdownSupported, $isDarkMode }) =>
    $isTaskBreakdownSupported &&
    `
      p {
        color: ${$isDarkMode ? secondaryColors.grey[200] : secondaryColors.grey[900]};
      }
      h2 {
        margin-top: 0;
      }
  `}

  ${({ $isAskEchoEnabled, $isDarkMode }) =>
    $isAskEchoEnabled &&
    css`
      *::selection {
        background: ${$isDarkMode ? 'rgba(65, 46, 96, 1)' : 'rgb(234, 203, 255)'};
        color: ${$isDarkMode ? 'rgba(215, 82, 255, 1)' : 'rgba(102, 0, 202, 1)'};
      }
    `}

  ${CredentialsCardStyles}
`;
